import React from 'react';
import { Notice } from 'telia-front-react';

interface Props {
  showNoticeWhen: string[];
  translate: (key: string) => string;
  status: string;
}

const resolveTranslationKeyFromStatus = (status: string) => {
  return status === 'ERROR' ? 'searchResults.searchError' : 'searchResults.searchLoadMoreError';
};

const SearchErrorNotice = (props: Props): JSX.Element => {
  if (!props.showNoticeWhen.includes(props.status)) {
    return null;
  }
  return (
    <Notice size="small" type="error" align="center">
      {props.translate(resolveTranslationKeyFromStatus(props.status))}
    </Notice>
  );
};

export default SearchErrorNotice;
